// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3hLjf","title":"Header_title__A8OyM","left":"Header_left__26uoW","clinicName":"Header_clinicName__1l8Hr"};